import { setShowEmailModal } from '../State/showEmailModal';

export default () => async (dispatch) => {

  dispatch(setShowEmailModal(false));
  
}